import { render, staticRenderFns } from "./ai-xiaomo.vue?vue&type=template&id=4bee9036&scoped=true&"
import script from "./ai-xiaomo.ts?vue&type=script&lang=js&"
export * from "./ai-xiaomo.ts?vue&type=script&lang=js&"
import style0 from "./ai-xiaomo.less?vue&type=style&index=0&id=4bee9036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee9036",
  null
  
)

export default component.exports